import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/axios';
import { Form, Button, Card, Alert } from 'react-bootstrap';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        try {
            const response = await apiClient.post('/users/forgot-password', { email });
            setMessage(response.data.message);
        } catch (err) {
            const errorMessage = err.response?.data?.detail || 'Произошла ошибка.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <Card className="shadow-sm">
                    <Card.Body>
                        <h2 className="card-title text-center mb-4">Сброс пароля</h2>
                        {message ? (
                            <Alert variant="success">{message}</Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <p className="text-muted">Введите ваш email, и мы пришлем вам ссылку для сброса пароля.</p>
                                {error && <Alert variant="danger">{error}</Alert>}
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                </Form.Group>
                                <div className="d-grid">
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {loading ? 'Отправка...' : 'Отправить ссылку'}
                                    </Button>
                                </div>
                            </Form>
                        )}
                        <div className="text-center mt-3">
                            <small><Link to="/login">Вернуться ко входу</Link></small>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
